
@let client = session.subjectData;
<div
  class="client-info-row rounded-lg overflow-hidden flex items-stretch"
  [class.has-actions]="(showArchiveButton || archived) && !collapsed"
  [ngClass]="{
    'client-selected': selected,
    'client-highlighted': highlight,
    'client-archived': archived
  }"
>
  <button
    pButton
    type="button"
    [text]="true"
    class="client-info-button flex-1 min-w-0 text-left flex items-stretch justify-between rounded-none"
    (click)="selectClient()"
  >
    <div class="text-left font-normal text-[inherit] text-base leading-normal w-full">
      <div class="w-full flex items-center gap-3 overflow-hidden">
        <p-avatar
          [label]="initials"
          shape="circle"
          [styleClass]="avatarStyleClass"
          [style]="{ flex: '0 0 auto', width: '2.5rem', height: '2.5rem' }"
          [pTooltip]="collapsed ? avatarTooltip : undefined"
          tooltipPosition="right"
        ></p-avatar>
        <ng-template #avatarTooltip>
          {{ client.firstName | capitalizeFirst }} {{ client.lastName | capitalizeFirst }}<br>
          {{ client.company | capitalizeFirst }}
        </ng-template>
        @if (!collapsed) {
          <div class="flex flex-col min-w-0 overflow-hidden">
            <div class="client-info-wrapper">
              <div class="client-name truncate">
                {{ client.firstName }} {{ client.lastName }}
              </div>
              <div class="client-company truncate">
                Company: {{ client.company | capitalizeFirst }}
              </div>
              @if (showGuid) {
                <div class="client-guid truncate">GUID: {{ client.guid }}</div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </button>

  @if ((showArchiveButton || archived) && !collapsed) {
    <div class="client-info-actions shrink-0">
      @if (showArchiveButton) {
        <button
          type="button"
          pButton
          icon="pi pi-times-circle"
          class="delete-button p-button-text p-button-sm p-button-danger"
          (click)="handleArchiveSession($event)"
          pTooltip="Archive conversation"
          tooltipPosition="bottom"
          aria-label="Archive conversation"
        ></button>
      }
      @if (archived) {
        <button
          type="button"
          pButton
          icon="{{ _activeSession() ? 'pi pi-envelope' : 'pi pi-plus-circle' }}"
          class="handle-archived-button p-button-text p-button-sm"
          (click)="handleActivateOrCreateSession($event)"
          [pTooltip]="_activeSession() ? 'Go to active conversation' : 'Start new conversation'"
          tooltipPosition="bottom"
          [attr.aria-label]="_activeSession() ? 'Go to active conversation' : 'Start new conversation'"
        ></button>
      }
    </div>
  }
</div>

@if (showFeedbackDialog) {
  <lib-feedback-dialog
    [visible]="true"
    [feedbackProps]="archivedChatFeedback"
    (closeDialog)="closeArchiveFeedback()"
    (canceled)="cancelArchiveFeedback()"
  ></lib-feedback-dialog>
}
